//GeneratorFlag:[NoChange]
<template>
	<div>kaveh.app.toolbar.aut.notification</div>
</template>